import { Timestamp, FieldValue, deleteField } from 'firebase/firestore';
import { licenseTimestampParts, normalizeLicenseDay, normalizeLicenseDateFields as normalize } from '@strenforcement/domain/licenseDates';
import { formatDateString } from '@strenforcement/domain/licenseExpiration';

/** Display the application day without changing the historical timestamps. */
export function getLicenseAppliedOn(data = {}) {
  try {
    if (data.appliedOn !== undefined) return normalizeLicenseDay(data.appliedOn, 'appliedOn');
    const value = data.dateApplied ?? data.dateCreated;
    if (typeof value === 'string' && /^\d{4}-?\d{2}-?\d{2}$/.test(value.trim())) return normalizeLicenseDay(value);
    const parts = licenseTimestampParts(value);
    return parts ? formatDateString(new Date(parts.seconds * 1000)) : null;
  } catch {
    return null;
  }
}

export function normalizeLicenseDateFields(data) {
  return normalize(data, {
    timestampFromParts: (seconds, nanoseconds) => new Timestamp(seconds, nanoseconds),
    isFieldValue: value => value instanceof FieldValue,
    isDeleteField: value => value.isEqual(deleteField())
  });
}
